import request from '@/utils/requestnew'
import baseUrl from './baseUrl'
import commonJs from '@/utils/common'

const BASE_URL = baseUrl + '/MallApi/carousel'

export default {
    //分页
    list(params) {
        params = params && commonJs.obj.removeNullKey(params)
        return request({
            url: BASE_URL + '/list',
            method: 'get',
            params,
        })
    },
    //保存
    save(data) {
        return request({
            url: BASE_URL + '/save',
            method: 'post',
            data
        })
    },

    //删除
    delete(params) {
        params = params && commonJs.obj.removeNullKey(params)
        return request({
            url: BASE_URL + '/delete',
            method: 'get',
            params
        })
    },

}